import axios from "axios";
import { OrderQueues } from "helpers/enums";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

interface IContext {
    orderChannels: IOrderChannel[]
    ordersSync: IOrderSync[]
    productInventories: IProductInventory[]
}

interface IOrderChannel {
    id: string
    orderId: string
    channelDescription: string
    orderDate: moment.Moment
}

interface IOrderSync {
    id: string
    orderId: string
    orderDate: moment.Moment
    errorType: string
    errors: string[]
}

interface IProductInventory {
    sku: string
    b2BInfo: IProductInfo
    b2CInfo: IProductInfo
}

interface IProductInfo {
    quantity?: number
    lastUpdatedOn?: moment.Moment
}

export let dashboardContext = React.createContext({} as IContext);

let { Provider } = dashboardContext;

let DashboardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let location = useLocation();

    let [orderChannels, setOrderChannels] = useState<IOrderChannel[]>([]);
    let [ordersSync, setOrdersSync] = useState<IOrderSync[]>([]);
    let [productInventories, setProductInventories] = useState<IProductInventory[]>([]);

    useEffect(() => {
        let state = location.state as any;

        if (state?.search.queue === OrderQueues.Dashboard) {
            getOrderChannelsDashboard();
            getOrdersSyncDashboard();
            getInventoryUpdatesDashboard();
        }
    }, [])


    let getOrderChannelsDashboard = async () => {
        try {
            let res = await axios.get('/api/Order/GetOrderChannelsDashboard');
            setOrderChannels(res.data.items);
        } catch (err) { }
    }

    let getOrdersSyncDashboard = async () => {
        try {
            let res = await axios.get('/api/Order/GetOrdersSyncDashboard');
            setOrdersSync(res.data.items);
        } catch (err) { }
    }

    let getInventoryUpdatesDashboard = async () => {
        try {
            let res = await axios.get('/api/Inventory/GetInventoryUpdatesDashboard');
            setProductInventories(res.data.items);
        } catch (err) { }
    }


    return (
        <Provider
            value={{
                orderChannels,
                ordersSync,
                productInventories
            }}
        >
            {children}
        </Provider>
    )
}

export default DashboardProvider;